import { useTranslation } from "react-i18next";
import { useApi } from "../hooks/useApi";
import { ApiError, api } from "../lib/api";

export function AdminAnalytics(): JSX.Element {
  const { t } = useTranslation();
  const result = useApi(() => api.admin.analytics(500), []);

  if (result.status === "loading") {
    return <p className="launchpad__hint">{t("admin.loading")}</p>;
  }
  if (result.status === "error") {
    const msg = result.error instanceof ApiError ? result.error.message : result.error.message;
    return <p className="launchpad__hint launchpad__hint--error">{msg}</p>;
  }

  const { rows } = result.data;

  return (
    <section className="admin">
      <h2>{t("admin.analyticsTitle")}</h2>
      <table className="admin__table">
        <thead>
          <tr>
            <th>{t("admin.analytics.col.user")}</th>
            <th>{t("admin.analytics.col.app")}</th>
            <th>{t("admin.analytics.col.firstUsed")}</th>
            <th>{t("admin.analytics.col.lastUsed")}</th>
            <th>{t("admin.analytics.col.calls")}</th>
            <th>{t("admin.analytics.col.totalDuration")}</th>
            <th>{t("admin.analytics.col.avgDuration")}</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={`${row.user_id}:${row.app_slug}`}>
              <td>
                {row.display_name ?? row.email ?? <code>{row.user_id}</code>}
                {row.email && row.display_name ? (
                  <span className="admin__sub">{row.email}</span>
                ) : null}
              </td>
              <td>
                <code>{row.app_slug}</code>
              </td>
              <td>{new Date(row.first_used_at).toLocaleString()}</td>
              <td>{new Date(row.last_used_at).toLocaleString()}</td>
              <td>{row.call_count.toLocaleString()}</td>
              <td>{formatDuration(row.total_duration_ms)}</td>
              <td>{formatDuration(Math.round(row.total_duration_ms / row.call_count))}</td>
            </tr>
          ))}
          {rows.length === 0 ? (
            <tr>
              <td colSpan={7} className="admin__empty">
                {t("admin.analytics.empty")}
              </td>
            </tr>
          ) : null}
        </tbody>
      </table>
    </section>
  );
}

function formatDuration(ms: number): string {
  if (ms < 1000) return `${ms} ms`;
  return `${(ms / 1000).toFixed(1)} s`;
}
